<template>
    <div class="more-info-block">
        <ul class="tabs-nav">
            <li
                v-if="lenderDescription && lenderDescription !== undefined"
                :class="{'active': IsActive}"
                @click="toggleVisibility">
                About this lender
            </li>
            <li
                v-if="offer && offer !== undefined && isNullOrZeroCheck(offer.LockTermDays)"
                :class="{'active': !IsActive}"
                @click="toggleVisibility">
                Offer conditions
            </li>
        </ul>
        <div class="tab-content">
            <div
                v-if="offer && offer !== undefined && lenderDescription && lenderDescription !== undefined"
                class="about-lender"
                :class="{'active': IsActive}">
                <p class="about-lender" v-html="lenderDescription"></p>
            </div>
            <div v-if="offer && offer !== undefined && isNullOrZeroCheck(offer.LockTermDays)" class="offer-conditions" :class="{'active': !IsActive}">
                <h4>Offer conditions</h4>
                <div class="table-responsive">
                    <table class="offers-details-table">
                        <tbody>
                            <tr>
                                <th>Requested Loan Amount</th>
                                <td class="rate-table-loan-amount">${{ offer.LoanAmount|currency }}</td>
                            </tr>
                            <tr>
                                <th>Lock Period</th>
                                <td>{{ offer.LockTermDays }} Days</td>
                            </tr>
                            <tr>
                                <th>Principal and Interest Payments</th>
                                <td>${{ offer.PIPayment|currency }}</td>
                            </tr>
                            <tr>
                                <th>Estimated Mortgage Insurance Payments</th>
                                <td>${{ offer.MIPayment|currency }}</td>
                            </tr>
                            <tr>
                                <th>Total Monthly Mortgage Payment</th>
                                <td>${{ offer.TotalMonthlyPayment|currency }}</td>
                            </tr>
                            <tr>
                                <th>Lender Fees</th>
                                <td>${{ offer.TotalFees + offer.TotalCredits|currency }}</td>
                            </tr>
                            <tr>
                                <th>Lender Credit</th>
                                <td>${{ offer.TotalCredits|currency }}</td>
                            </tr>
                            <tr>
                                <th>Total Closing Fees*</th>
                                <td>${{ offer.TotalFees|currency }}</td>
                            </tr>
                            <tr>
                                <td colspan="2">*Other 3rd party fees may apply</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';

    export default {
        props: {
            offer: {
                default() {
                    return {};
                },
            },
            isActive: {
                default: true,
            },
            isAboutSectionVisibile: {
                default: true,
            },
            isOfferSectionVisibile: {
                default: true,
            },
            lenderDescription: {
                default: '',
            },
        },
        data() {
            return {
                IsActive: this.isActive,
                IsAboutSectionVisibile: this.isAboutSectionVisibile,
                IsOfferSectionVisibile: this.isOfferSectionVisibile,
            };
        },
        methods: {
            updateParent() {
                this.$emit('updateDetailSectionToggleLink');
            },
            toggleVisibility() {
                this.IsActive = self.IsAboutSectionVisibile && self.IsOfferSectionVisibile ? !this.IsActive : this.IsActive;
            },
            isNullOrZeroCheck(value) {
                // eslint-disable-next-line eqeqeq
                const localValue = value == undefined && isNaN(value) ? 0 : value;
                return localValue && parseFloat(localValue) > 0;
            },
            isLenderSectionVisibile() {
                this.IsOfferSectionVisibile = this.offer && this.offer !== undefined
                    && this.isNullOrZeroCheck(this.offer.LockTermDays)
                    && this.isNullOrZeroCheck(this.offer.TotalCredits)
                    && this.isNullOrZeroCheck(this.offer.PIPayment)
                    && this.isNullOrZeroCheck(this.offer.MIPayment)
                    && this.isNullOrZeroCheck(this.offer.TotalMonthlyPayment)
                    && this.isNullOrZeroCheck(this.offer.TotalFees)
                    && this.isNullOrZeroCheck(this.offer.TotalCredits);
            },
        },
        filters: {
            currency(val) {
                return Accounting.formatNumber(val);
            },
        },
        mounted() {
            this.isLenderSectionVisibile();
            this.IsAboutSectionVisibile = this.offer && this.offer !== undefined && this.lenderDescription !== undefined && this.lenderDescription;
            this.IsActive = this.IsAboutSectionVisibile ? this.IsActive : !this.IsActive;
            if (!this.IsAboutSectionVisibile && !this.IsOfferSectionVisibile) {
                this.updateParent();
            }
        },
    };
</script>
